import React from 'react'
import clsx from 'clsx'
import styles from './Button.module.scss'
export { styles as stylesButton }

export type ButtonAlign = 'left' | 'center' | 'right'

// Define a type that extends React button element attributes
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string
  icon?: React.ReactNode
  align?: ButtonAlign
}

export const Button: React.FC<ButtonProps> = ({ className, children, icon, align, ...props }) => {
  const alignClassName = (() => {
    switch (align) {
      case 'left':
        return styles.buttonAlignLeft
      case 'center':
        return styles.buttonAlignCenter
      case 'right':
        return styles.buttonAlignRight
      default:
        return undefined
    }
  })()

  const buttonClassName = clsx(styles.button, alignClassName, className, icon && styles.buttonIcon)
  return (
    <button className={buttonClassName} {...props}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {children || 'Button'}
    </button>
  )
}
